// WO-MEMBER-STATE-PROPAGATION-001 · P0 sweep — the two status colours, out from behind the client
// boundary. Same class as the `splitPricePair` 500: `mountain-catalogue.tsx` is `"use client"`, and
// `components/map/pin-markers.ts` (server-rendered) imported these constants out of it. Latent rather
// than firing today, which is exactly why it needed finding by a scanner rather than by a 500.
export const STATUS_GREEN = "#2a9d8f";
export const STATUS_YELLOW = "#e9b949";
